import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const TONE_STYLES = {
    orange: "from-[#EE722E] to-[#F89F63] text-white shadow-btn",
    yellow: "from-[#FCDB53] to-[#F89F63] text-shariti-black",
    green: "from-[#16A34A] to-[#22C55E] text-white",
    red: "from-[#DC2626] to-[#F87171] text-white",
    dark: "from-[#181818] to-[#404040] text-white",
    light: "bg-white text-shariti-black border border-shariti-gray",
};

export default function KpiTile({
    label,
    value,
    hint,
    icon: Icon,
    tone = "light",
    testId,
    suffix,
    to,
}) {
    const isGradient = tone !== "light";
    const Wrapper = to ? Link : "div";
    const wrapperProps = to ? { to } : {};

    return (
        <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            whileHover={to ? { y: -2 } : {}}
            className="h-full"
        >
            <Wrapper
                {...wrapperProps}
                data-testid={testId}
                className={`group relative h-full overflow-hidden rounded-3xl p-5 md:p-6 transition-all duration-300 flex flex-col ${
                    isGradient
                        ? `bg-gradient-to-br ${TONE_STYLES[tone]} shadow-card-hover`
                        : TONE_STYLES.light + " shadow-card hover:shadow-card-hover"
                } ${to ? "cursor-pointer hover:-translate-y-0.5" : ""}`}
            >
                <div className="flex items-start justify-between gap-2">
                    <div className="text-[10px] font-bold uppercase tracking-widest opacity-70">
                        {label}
                    </div>
                    {Icon ? (
                        <div
                            className={`h-9 w-9 rounded-2xl flex items-center justify-center ${
                                isGradient
                                    ? "bg-white/15"
                                    : "bg-shariti-orange-soft text-shariti-orange"
                            }`}
                        >
                            <Icon className="h-4.5 w-4.5" strokeWidth={2.4} />
                        </div>
                    ) : null}
                </div>
                <div className="mt-4 flex items-baseline gap-1">
                    <span className="text-4xl md:text-[42px] font-black tracking-tight">
                        {value ?? 0}
                    </span>
                    {suffix ? (
                        <span className="text-base font-bold opacity-70">{suffix}</span>
                    ) : null}
                </div>
                {hint ? (
                    <p className="mt-2 text-xs font-semibold opacity-70">{hint}</p>
                ) : null}
                {to ? (
                    <span
                        className={`mt-3 inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-widest opacity-0 group-hover:opacity-100 transition ${
                            isGradient ? "" : "text-shariti-orange"
                        }`}
                    >
                        Ouvrir la liste →
                    </span>
                ) : null}
            </Wrapper>
        </motion.div>
    );
}
